import BorrowRate from './BorrowRate';

export * from './BorrowRate';

export default BorrowRate;
